module.exports = __webpack_public_path__ + "static/Bala-Dutt-f10d57bd27426b9b17a388fb22021084.png";